"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPartnerHostedLivestreamProperty = exports.partnerHostedLivestreamPropertyDefinition = void 0;
exports.partnerHostedLivestreamPropertyDefinition = {
    view: { label: 'Livestream Partner' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: [
                'partner-hosted-livestream-streaming-partner',
                'partner-hosted-livestream-target-country-code',
                'partner-hosted-livestream-cta-container',
                'partner-hosted-livestream-post-stream-exclusive-timespan',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'partner-hosted-livestream',
};
const isPartnerHostedLivestreamProperty = (prop) => {
    return prop.name === exports.partnerHostedLivestreamPropertyDefinition.name;
};
exports.isPartnerHostedLivestreamProperty = isPartnerHostedLivestreamProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFydG5lci1ob3N0ZWQtbGl2ZXN0cmVhbS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3BhcnRuZXItaG9zdGVkLWxpdmVzdHJlYW0ucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBTWEsUUFBQSx5Q0FBeUMsR0FBRztJQUN2RCxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsb0JBQW9CLEVBQUU7SUFDckMsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsbUJBQW1CO1lBQ3pCLFFBQVEsRUFBRTtnQkFDUiw2Q0FBNkM7Z0JBQzdDLCtDQUErQztnQkFDL0MseUNBQXlDO2dCQUN6QywwREFBMEQ7YUFDM0Q7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLG1CQUFtQjtJQUN6QixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSwyQkFBMkI7Q0FDRixDQUFBO0FBVzFCLE1BQU0saUNBQWlDLEdBQUcsQ0FBQyxJQUFrQixFQUEyQyxFQUFFO0lBQy9HLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxpREFBeUMsQ0FBQyxJQUFJLENBQUE7QUFDckUsQ0FBQyxDQUFBO0FBRlksUUFBQSxpQ0FBaUMscUNBRTdDIn0=